import { render, staticRenderFns } from "./handpickAuthorList.vue?vue&type=template&id=e85ddc70&scoped=true&"
import script from "./handpickAuthorList.vue?vue&type=script&lang=js&"
export * from "./handpickAuthorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85ddc70",
  null
  
)

export default component.exports